import api from "api"

const sessions = {
    get: (slug) => {
        return api().get(`/events/detail/${slug}/sessions`)
    },
    create: (slug, payload) => {
        return api().post(`/events/detail/${slug}/sessions`, payload);
    },
    update: (slug, id, payload) => {
        return api().put(`/events/detail/${slug}/sessions/${id}`, payload);
    },
    delete: (slug, id) => {
        return api().delete(`/events/detail/${slug}/sessions/${id}`);
    },
    updateLayout: (slug, layout) => {
        return api().put(`/events/detail/${slug}/layout`, { layout });
    }
}

export default sessions;
